/*
 * layout view for the response area
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicResponse/template/topicResponseTemplate.html",
], function (Marionette, TopicResponseTemplate) {
  "use strict";

  const TopicResponseView = {};

  TopicResponseView.topicResponseLayout = Marionette.Layout.extend({
    template: TopicResponseTemplate,
    events: {
      "show #aaLink": function (e) {
        this.trigger("show:agentAssist", e);
      },
      "show #catLink": function (e) {
        this.trigger("show:categories", e);
      },
      "show #attLink": function (e) {
        this.trigger("show:attributes", e);
      },
      "show #responseLink": function (e) {
        this.trigger("show:preview", e);
      },
    },
    triggers: {
      "click #aaLink": "click:agentAssist",
      "click #catLink": "click:categories",
      "click #attLink": "click:attributes",
      "click #responseLink": "click:preview",
    },
    hideAgentAssistTab: function () {
      this.$el.find("#aaLi").addClass("hidden");
    },
    hideCategoriesTab: function () {
      this.$el.find("#catLi").addClass("hidden");
    },
    regions: {
      properties: "#responseProperties",
      preview: "#responsePreview",
      agentAssist: "#aaTab",
      categories: "#categoryContentList",
      categoriesHeader: "#category-Header",
      tasks: "#responseTasks",
      topicAttributes: "#attTab",
    },
    ui: {
      agentAssistTab: "#aaLink",
      attributesTab: "#attLink",
      categoriesTab: "#catLink",
      responseTab: "#responseLink",
    },
    selectAgentAssistTab: function () {
      this.ui.agentAssistTab.tab("show");
    },
    selectAttributesTab: function () {
      this.ui.attributesTab.tab("show");
    },
    selectCategoriesTab: function () {
      this.ui.categoriesTab.tab("show");
    },
    selectResponseTab: function () {
      this.ui.responseTab.tab("show");
    },
    showAgentAssistTab: function () {
      this.$el.find("#aaLi").removeClass("hidden");
    },
    showCategoriesTab: function () {
      this.$el.find("#catLi").removeClass("hidden");
    },
    showAttributes: function () {
      this.$el.find("#attLi").removeClass("hidden");
    },
  });

  return TopicResponseView;
});
